import { parseYmdToLocalDate } from "./parseYmdToLocalDate";

/**
 * Returns true if the pack is active (not expired).
 * A pack is active if "today" (local calendar day) is BEFORE or EQUAL to the expire date.
 */
export const isActive = (expireStr, now = new Date()) => {
  const exp = parseYmdToLocalDate(expireStr);
  if (!exp) return false;
  
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return today.getTime() <= exp.getTime();
};

